import React, {useEffect} from 'react';
import {yupResolver} from '@hookform/resolvers/yup';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import IconButtonMUI from '../../../shared/IconButtonMUI';
import RadioMUI from '../../../shared/RadioMUI';
import ButtonMUI from '../../../shared/ButtonMUI';
import SelectComponent from '../../../shared/SelectComponent';
import {ReactComponent as CloseIcon} from '../../../assets/icons/closeFilter.svg';
import {ReactComponent as OkIcon} from '../../../assets/icons/ok.svg';
import {ReactComponent as ClosesIcon} from '../../../assets/icons/closesBtn.svg';

import './Filter.scss';
import {ReactComponent as ProjectIcon} from '../../../assets/icons/project-btn.svg';
import {notifyError} from '../../../helpers/notifySnack';
import {getProjectTypes, setFilterStatusProject} from '../../../redux/actions/projects/projectsActions';
import {getCities} from '../../../redux/actions/countries/countriesActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../LoadPanel';
import {useHistory} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import {useTranslation} from 'react-i18next';
import {AutocompleteMUI} from "../../../shared";

const Filter = ({onClose, setFilters}) => {
    const history = useHistory();
    const companyList = useSelector(({company}) => company.companies);
    const {cities, citiesLoading} = useSelector(({countries}) => countries);
    const {projectTypes, projectTypesLoading} = useSelector(({projects}) => projects);
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // const projectStatuses = [
    //     {name: t('ProjectsCheckboxPanel.all'), id: 'all'},
    //     {name: t('CompaniesHome.active'), id: 'active'},
    //     {name: t('CompaniesHome.paused'), id: 'pause'},
    //     {name: t('CompaniesHome.done'), id: 'done'}
    // ];

    const schema = yup.object({});

    const {control, handleSubmit, setValue} = useForm({
        mode: 'onTouched',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            city: '',
            projectType: [],
            companyId: '',
            projectStatus: 'all'
        }
    });

    const onSubmit = async (data) => {
        const filters = [];


        if (data.city) {
            filters.push(`city=${data.city}`);
        }
        if (data.projectType && data.projectType.length > 0) {
            data.projectType.forEach(item => filters.push(`pT=${item.label}`));
        }
        if (data.companyId) filters.push(`cId=${data.companyId}`);
        if (data.projectStatus && data.projectStatus !== 'all') filters.push(`pS=${data.projectStatus}`);

        const searchParams = filters.join('&');

        history.push(`?${searchParams}`);

        onClose();
    };

    const handleResetFilters = () => {
        setFilters([]);
        onClose();
        dispatch(setFilterStatusProject('all'))
        history.push(mainPath.projects);
    };

    useEffect(() => {
        const fetchFunc = async () => {
            try {
                if (citiesLoading) {
                    const citiesResponse = await dispatch(getCities());
                    if (citiesResponse.error) {
                        return;
                    }
                }
                if (projectTypesLoading) {
                    const projectTypesRes = await dispatch(getProjectTypes());
                    if (projectTypesRes.error) {
                    }
                }
            } catch (error) {
                notifyError(error.message || 'error');
            }
        };

        fetchFunc();
    }, []);

    const getFiltersFromUrl = (searchParams) => {
        const filters = [];

        const city = searchParams.get('city');
        const projectTypes = searchParams.getAll('pT'); // Use getAll for repeated parameters
        const companyId = searchParams.get('cId');
        const projectStatus = searchParams.get('pS');

        if (city) filters.push({id: 'city', value: city});
        if (projectTypes.length > 0) filters.push({id: 'pT', value: projectTypes}); // No need to split
        if (companyId) filters.push({id: 'cId', value: companyId});
        if (projectStatus) filters.push({id: 'pS', value: projectStatus});

        return filters;
    };

    const mappedProjectTypes = projectTypes?.map((p) => {
        return {
            id: p.id,
            label: p.name
        }
    })

    const setFormValues = (filters) => {
        filters.forEach(({id, value}) => {

            if (id === 'city') {
                setValue(id, value);
            }

            if (id === 'pS') {
                setValue('projectStatus', value);
            }
            if (id === 'cId') {
                setValue('companyId', value);
            }
            if (id === 'pT' && Array.isArray(value)) {
                const projectTypes = mappedProjectTypes.filter(item => value.includes(item.label));

                if (projectTypes.length > 0) {
                    setValue('projectType', projectTypes);
                }
            }
        });
    };

    useEffect(() => {
        if (cities?.length > 0 && projectTypes.length > 0) {
            const searchParams = new URLSearchParams(location.search);
            const filters = getFiltersFromUrl(searchParams);
            setFormValues(filters);
        }
    }, [location.search, setValue, cities, projectTypes]);


    return (
        <div className='filter'>
            {citiesLoading || projectTypesLoading ? (
                <LoadPanel noBg={true} circleSize={40} staticPos={true}/>
            ) : (
                <>
                    <div className='filter__header'>
                        <div className='filter__header-title'>{t('Filter.filters')}</div>

                        <div className='filter__header-btn'>
                            <IconButtonMUI color='primary' className='project'>
                                <ProjectIcon/>
                            </IconButtonMUI>
                            <IconButtonMUI color='primary' onClick={onClose}>
                                <CloseIcon/>
                            </IconButtonMUI>
                        </div>
                    </div>

                    <div className='filter__group'>
                        <Controller
                            name='city'
                            control={control}
                            render={({field}) => (
                                <SelectComponent
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={cities.find((c) => c.id === field.value)}
                                    options={cities}
                                    label={t('Filter.city')}
                                    placeholder=''
                                    inputProps={field}
                                    disabled={!cities.length}
                                />
                            )}
                        />
                    </div>

                    <div className='filter__group'>
                        <Controller
                            name='companyId'
                            control={control}
                            render={({field}) => (
                                <SelectComponent
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    value={companyList.find((c) => c.id === field.value)}
                                    options={companyList}
                                    label={t('Filter.company')}
                                    placeholder=''
                                    inputProps={field}
                                    disabled={!cities.length}
                                />
                            )}
                        />
                    </div>

                    <div className='filter__group'>
                        <Controller
                            name='projectType'
                            control={control}
                            render={({field}) => (
                                <AutocompleteMUI
                                    className='no-icons'
                                    text={t('Filter.projectType')}
                                    inputProps={field}
                                    array={mappedProjectTypes}
                                    value={field.value}
                                    onChange={field.onChange}
                                    withoutAvatars={true}
                                />
                            )}
                        />
                    </div>

                    {/*<div className='filter__group'>*/}
                    {/*    <div className='filter__group-title'>{t('Filter.projectStatus')}</div>*/}
                    {/*    <div className='filter__group-radio'>*/}
                    {/*        <Controller*/}
                    {/*            name='projectStatus'*/}
                    {/*            control={control}*/}
                    {/*            render={({field: {onChange, value}}) =>*/}
                    {/*                projectStatuses.map(({id, name}, idx) => (*/}
                    {/*                    <RadioMUI key={idx} checked={value === id} onChange={() => onChange(id)}*/}
                    {/*                              value={id} label={name}/>*/}
                    {/*                ))*/}
                    {/*            }*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className='filter__wrapper-btn'>
                        <ButtonMUI startIcon={<OkIcon/>} onClick={handleSubmit(onSubmit)}>
                            <span className='hidden'>ОК</span>
                            <span className='visible'>{t('Filter.apply')}</span>
                        </ButtonMUI>

                        <ButtonMUI color={'secondary'} startIcon={<ClosesIcon/>} onClick={handleResetFilters}
                                   formAction>
                            <span className='hidden'>{t('Filter.reset')}</span>
                            <span className='visible'>{t('Filter.resetAll')}</span>
                        </ButtonMUI>
                    </div>
                </>
            )}
        </div>
    );
};

export default Filter;
